import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const violationsUserSlice = createSlice({
  name: 'aag/violationsUser',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

const { reducer: violationsUserReducer, actions } = violationsUserSlice;

export const violationsUserActions = actions;
export default violationsUserReducer;
